import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiInstance } from '../../axiosApi';

export const unassignListGet = createAsyncThunk('help-desk/unassign', async (params) => {
  return await apiInstance.get('/help-desk/unassign/whatsapp', { params });
});

export const assignListGet = createAsyncThunk('help-desk/assign', async (params) => {
  return await apiInstance.get('/help-desk/assign/whatsapp', { params });
});

export const helpHistoryGet = createAsyncThunk('help-desk/chat-history', async (params) => {
  return await apiInstance.get('/help-desk/whatsapp/chat-history', { params });
});

export const unreadCountGet = createAsyncThunk('help-desk/unread', async (params) => {
  return await apiInstance.get('/help-desk/whatsapp/unread', { params });
});

export const helpMarkAsRead = createAsyncThunk('help-desk/mark-read', async (payload) => {
  return await apiInstance.put('/help-desk/whatsapp/mark-read', payload);
});

export const sendHelpMsg = createAsyncThunk('help-desk/send-message', async (formData) => {
  return await apiInstance.post('/help-desk/whatsapp/send-message', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
});

export const assignToAgent = createAsyncThunk('help-desk/assign-to-agent', async (payload) => {
  return await apiInstance.post('/help-desk/whatsapp/assign-to-agent', payload);
});

export const addHelpNote = createAsyncThunk('help-desk/note', async (payload) => {
  return await apiInstance.post('/help-desk/whatsapp/note', payload);
});

export const getHelpNote = createAsyncThunk('help-desk/get-note', async (params) => {
  return await apiInstance.get('/help-desk/whatsapp/get-note', { params });
});

export const whatsappEditDetails = createAsyncThunk(
  'help-desk/whatsapp/edit-details',
  async (payload) => {
    return await apiInstance.put('/help-desk/whatsapp/edit-details', payload);
  }
);

export const whatsappAddDetails = createAsyncThunk(
  'help-desk/whatsapp/optional-send-message',
  async (payload) => {
    return await apiInstance.post('/help-desk/whatsapp/optional-send-message', payload);
  }
);

const initialState = {
  unassignList: [],
  assignList: [],
  activeHelpDetails: null,
  helpCountList: []
};

const helpDeskSlice = createSlice({
  name: 'helpDesk',
  initialState,
  reducers: {
    setActiveHelpDetails(state, action) {
      state.activeHelpDetails = action.payload;
    },
    clearHelpDeskSlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(unassignListGet.fulfilled, (state, action) => {
      const data = [...(action?.payload?.data || [])];
      state.unassignList = data?.map((val) => {
        return {
          ...val,
          name: val?.from_name,
          id: val?._id
        };
      });
    });
    builder.addCase(assignListGet.fulfilled, (state, action) => {
      const data = [...(action?.payload?.data || [])];
      state.assignList = data?.map((val) => {
        return {
          ...val,
          name: val?.from_name,
          id: val?._id
        };
      });
    });
    builder.addCase(unreadCountGet.fulfilled, (state, action) => {
      state.helpCountList = [...(action?.payload?.data || [])];
    });
  }
});

export default helpDeskSlice.reducer;
export const { clearHelpDeskSlice, setActiveHelpDetails } = helpDeskSlice.actions;

export const selectUnassignList = (state) => state.helpDesk.unassignList;
export const useUnassignList = () => {
  const unassignList = useSelector(selectUnassignList);
  return useMemo(() => unassignList, [unassignList]);
};

export const selectAssignList = (state) => state.helpDesk.assignList;
export const useAssignList = () => {
  const assignList = useSelector(selectAssignList);
  return useMemo(() => assignList, [assignList]);
};

export const selectActiveHelpDetails = (state) => state.helpDesk.activeHelpDetails;
export const useActiveHelpDetails = () => {
  const activeHelpDetails = useSelector(selectActiveHelpDetails);
  return useMemo(() => activeHelpDetails, [activeHelpDetails]);
};

export const selectHelpCountList = (state) => state.helpDesk.helpCountList;
export const useHelpCountList = () => {
  const helpCountList = useSelector(selectHelpCountList);
  return useMemo(() => helpCountList, [helpCountList]);
};
